import { Header } from '@/shared/components';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { ChatBody } from '../../components/chat-body/chat-body';
import { ChatFooter } from '../../components/chat-footer/chat-footer';
import { ChatStore } from '../../store';
import { BotConfigService, ChatEngineService } from '../../services';

@Component({
  selector: 'bevvi-chat-panel',
  imports: [Header, ChatBody, ChatFooter],
  templateUrl: './chat-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatPanel implements OnInit {
  public readonly closing = input(false);

  private readonly chatStore = inject(ChatStore);
  private readonly chatEngine = inject(ChatEngineService);
  private readonly botConfig = inject(BotConfigService);

  protected readonly messages = this.chatStore.messages;
  protected readonly loading = this.chatStore.loading;
  protected readonly config = this.botConfig.config;

  protected readonly headerLogo = computed(() => this.config()?.logo_b64url ?? 'assets/images/logo.png');

  public readonly close = output<void>();

  public ngOnInit(): void {
    if (!this.chatStore.sessionId()) {
      this.chatEngine.initializeConversation();
    }
  }

  public sendMessage(message: string, sourceMessageId?: string): void {
    this.chatEngine.sendMessage(message, sourceMessageId);
  }

  

  public onUserReply(event: { label: string; sourceMessageId: string }): void {
    this.chatEngine.sendMessage(event.label, event.sourceMessageId);
  }

  public startNewChat(): void {
    this.chatStore.clearMessages();
    this.chatEngine.initializeConversation();
  }
}
